<!-- 采购计划数据操作 -->
<template>
    <div>
      <subComponents ref="showSelectData"></subComponents>
      <purchaseGoodsTemplate @selectDataAction="selectDataAction" ref="purchaseGoodsTemplate"></purchaseGoodsTemplate>
      <el-dialog :visible.sync="dataActionBox.showStatus" width="700px">
        <div class="demo-drawer__content">
          <el-tabs type="border-card" v-model="showTabs" class="el-tabs--border-card_new">
            <el-tab-pane v-for="(formListValue,formKey) in formDataList" :key="formKey" :label="formListValue.jciName" :name="formListValue.jciName" v-if="formListValue.isShowForm!=1">
              <div class="table_content_box" v-if="formListValue.isShowForm!=1">
                <!-- 主要信息 -->
                <div v-if="formKey == 0">
                  <el-form label-width="100px" ref="sendDataInfo" :model="sendDataInfo" size="mini" class="baseForm" id="mainInfo">
                    <el-row>
                      <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" :rules="formOneValue.isRequired == 1 ? [{required: true, message: '不能为空', trigger: ['blur', 'change']}] : []" v-for="(formOneValue,formOneKey) in formListValue.jurconfigform" :key="formOneKey">
                        <!-- 开始日期 -->
                        <df-date :isShowLong="formOneValue.entityField != 'pspmSdate'" :isdisabled="formOneValue.isChange == 0" v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneKey,formOneValue.focusField)"></df-date>
                        <!-- 商品分类 -->
                        <!-- <el-select v-else-if="formOneValue.entityField == 'bgiType'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                          <el-option v-for="(values,keys) in goodsCate" :key="keys" :label="values.diName" :value="values.diValue">
                          </el-option>
                        </el-select> -->
                        <el-select size="mini" v-else-if="formOneValue.fieldType == 'formatter' && formOneValue.isShow" @change="(val) => {
                handleChange(val, formOneValue.entityField);
              }
                " v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key"
                  :value="matItem.value">
                </el-option>
              </el-select>
              <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
          :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                        <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1">
                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1">
                          </el-button>
                        </el-input>
                        </el-tooltip>
                        <!-- 备注 -->
                        <el-input v-else-if="formOneValue.entityField == 'pspmRemark'" type="textarea" @keyup.enter.native="nextFocus(formOneKey,formOneValue.focusField)" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                        <!-- 补货天数 -->
                        <el-input v-else-if="formOneValue.entityField == 'pspmSupdays'" @keyup.enter.native="nextFocus(formOneKey,formOneValue.focusField)" v-model="sendDataInfo[formOneValue.entityField]" min="0" type="number"></el-input>
                        <!-- 其它 -->
                        <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneKey,formOneValue.focusField)" :maxlength="$store.state.inputLength"></el-input>
                      </el-form-item>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
  
          <div style="margin-top: 1rem;text-align: center;" v-if="formDataList[2]">
            <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
              <el-form-item :label="itemV.chineseField" v-for="(itemV,itemK) in formDataList[2].jurconfigform" :key="itemK">
                <el-button type="success">{{sendDataInfo[itemV.entityField]}}</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 1rem;text-align: center;">
            <el-button type="primary" @click="initActionBox">取消</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">查询</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
        <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
    </div>
  
  </template>
  
  <script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import NP from "number-precision";
  import purchaseGoodsTemplate from "@/components/purchaseGoodsTemplate.vue";
  export default {
    name: "purchasePlanAutoAction",
    props: [],
    //import引入的组件需要注入到对象中才能使用
    components: {purchaseGoodsTemplate},
    data() {
      //这里存放数据
      return {
        selectDataTable: false,
        detaislDataInfo: {},
        dataActionBox: {
          showStatus: false,
          openMode: "ltr" || "rtl",
          boxTitle: "新增" || "编辑",
          actionType: 0, // 0新增，1修改
        },
        sendDataInfo: {
          coId: "",
          coName: "",
          smName: "",
          smId: '',
          opmName: '',
          opmId: '',
          pspmEdate: "",
          bgiType: "",
          pspmSdate: "",
          pspmSupdays: 0,
        },
        showTabs: "",
        formDataList: [],
        goodsCate: [],
        storageRoomList: [],
        detailsBox: {
          status: false,
          type: 0,
          title: "新增" || "修改",
        },
        editDateilsIndex: "",
        seId: "",
        seWidth: "",
        height: "",
        seTitle: "",
        seWidth: "",
        DialogVisible: false,
        seType: "",
        sField: '',
        seIndex: 0,
        parentSearchData:{}
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
  
    },
    //方法集合
    methods: {
      handleChange(value, name) {
        console.log(value, name);
        // value默认参，name当前所需的name
        this.sendDataInfo[name] = value;
      },
       getSeWidth(e) {
        console.log(e);
        this.seWidth = e + "%";
      },
      getSearchName(e) {
        console.log(e);
        this.seTitle = e;
      },
      //检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
        this.DialogVisible = true;
        this.seId = sId;
        this.seIndex = index;
        this.seType = type;
        this.sField = sField;
        this.parentSearchData[type] = this.sendDataInfo[type]
      },
      // 赋值字段
      paramValue(val) {
        let arr = this.sField.split(',')
        arr.forEach(item => {
          this.sendDataInfo[item] = val[item]
        })
        // this.$nextTick(() => {
        // 	this.nextFocus(this.seIndex)
        // })
      },
      changeInputModel(val) {
        if (val != "" || val != undefined) {
          this.DialogVisible = false;
          this.paramValue(val)
        }
      },
      tableRowClassName({ row, rowIndex }) {
        row.index = rowIndex;
      },
      openDateilsBox(row, column, event) {
        if (row) {
          this.editDateilsIndex = row.index;
          this.detailsBox.title = "修改明细信息";
          this.detaislDataInfo = JSON.parse(JSON.stringify(row));
        } else {
          this.detaislDataInfo = {
            bgmInternalcode: "",
            bgmName: "",
            bgmManufacturer: "",
            bgmSpecifications: "",
            bgmPlaceorigin: "",
            pspdIntaxrate: "",
            pspdMoney: 0,
            pspdPrice: 0,
            pspdPsdvolume: "",
            pspdPslowerlimit: "",
            pspdPsmoney: 0,
            pspdPsnumber: 0,
            pspdPsnvolume: "",
            pspdPsownumber: "",
            pspdPsprice: 0,
            pspdPsupperlimit: "",
            pspdReserves1: "",
            pspdReserves2: "",
            pspdReserves3: "",
            pspdReserves4: "",
            pspdReserves5: "",
            pspdReserves6: "",
            pspmId: "",
            stId: "",
          };
          this.detailsBox.title = "新增明细信息";
        }
  
        this.detailsBox.status = true;
      },
      // 计算价格
      calculatePrice(cate = 1) {
        var info = this.detaislDataInfo;
        if (info.pspdPsnumber <= 0) {
          this.$message({
            message: "请先填写建议采购数量",
            type: "error",
          });
          return false;
        }
  
        switch (cate) {
          case 1: // 单价计算
            // 计算含税价格 单价+单价*税率/100
            var thisPrice = NP.plus(
              info.pspdPrice,
              NP.divide(NP.times(info.pspdPrice, info.pspdIntaxrate), 100)
            );
            this.detaislDataInfo.pspdPsprice = this.$common.getDecimalInfo(
              2,
              thisPrice
            );
  
            // 计算金额 单价*数量
            this.detaislDataInfo.pspdMoney = this.$common.getDecimalInfo(
              3,
              NP.times(info.pspdPrice, info.pspdPsnumber)
            );
  
            // 计算含税金额 含税价格*数量
            this.detaislDataInfo.pspdPsmoney = this.$common.getDecimalInfo(
              3,
              NP.times(thisPrice, info.pspdPsnumber)
            );
  
            break;
          case 2: // 含税价格计算
            // 计算单价 含税价格/(税率/100+1)
            var thisPrice = NP.divide(
              info.pspdPsprice,
              NP.plus(NP.divide(info.pspdIntaxrate, 100), 1)
            );
            this.detaislDataInfo.pspdPrice = this.$common.getDecimalInfo(
              2,
              thisPrice
            );
  
            // 计算金额 单价*数量
            this.detaislDataInfo.pspdMoney = this.$common.getDecimalInfo(
              3,
              NP.times(thisPrice, info.pspdPsnumber)
            );
  
            // 计算含税金额 含税价格*数量
            this.detaislDataInfo.pspdPsmoney = this.$common.getDecimalInfo(
              3,
              NP.times(info.pspdPsprice, info.pspdPsnumber)
            );
            break;
          case 3: // 通过总金额计算
            // 计算单价  总金额 / 数量
            var thisPrice = NP.divide(info.pspdMoney, info.pspdPsnumber);
            this.detaislDataInfo.pspdPrice = this.$common.getDecimalInfo(
              2,
              thisPrice
            );
  
            // 计算含税价格 单价+单价*税率/100
            var thisPriceTwo = NP.plus(
              thisPrice,
              NP.divide(NP.times(thisPrice, info.pspdIntaxrate), 100)
            );
            this.detaislDataInfo.pspdPsprice = this.$common.getDecimalInfo(
              3,
              thisPriceTwo
            );
  
            // 计算含税金额 含税价格*数量
            this.detaislDataInfo.pspdPsmoney = this.$common.getDecimalInfo(
              3,
              NP.times(thisPriceTwo, info.pspdPsnumber)
            );
            break;
  
          case 4: // 通过含税金额计算
            // 计算含税价格  含税金额 / 数量
            var thisPrice = NP.divide(info.pspdPsmoney, info.pspdPsnumber);
            this.detaislDataInfo.pspdPsprice = this.$common.getDecimalInfo(
              2,
              thisPrice
            );
  
            // 计算单价 含税价格/(税率/100+1)
            var thisPriceTwo = NP.divide(
              thisPrice,
              NP.plus(NP.divide(info.pspdIntaxrate, 100), 1)
            );
            this.detaislDataInfo.pspdPrice = this.$common.getDecimalInfo(
              2,
              thisPriceTwo
            );
  
            // 计算总金额 单价*数量
            this.detaislDataInfo.pspdMoney = this.$common.getDecimalInfo(
              3,
              NP.times(thisPriceTwo, info.pspdPsnumber)
            );
            break;
          default:
            // 通过数量计算
            // 计算金额 单价*数量
            this.detaislDataInfo.pspdMoney = this.$common.getDecimalInfo(
              3,
              NP.times(info.pspdPrice, info.pspdPsnumber)
            );
            // 计算含税金额 含税价格*数量
            this.detaislDataInfo.pspdPsmoney = this.$common.getDecimalInfo(
              3,
              NP.times(info.pspdPsprice, info.pspdPsnumber)
            );
            break;
        }
      },
      // 获取所有可用库房列表
      async getAllStorageRoom() {
        let responseData = await this.$http.getAllStorageRoom();
        if (responseData.status == 200) {
          this.storageRoomList = responseData.result;
        } else {
          this.$message({
            message: responseData.message,
            type: "error",
          });
        }
      },
  
      selectDataAction(data) {
        this.detaislDataInfo = {
          bgmInternalcode: data.bgmId,
          bgmName: data.bgmName,
          bgmManufacturer: data.bgmManufacturer,
          bgmSpecifications: data.bgmSpecifications,
          bgmPlaceorigin: data.bgmPlaceorigin,
          pspdIntaxrate: data.bgfIntaxrate,
          pspdMoney: 0,
          pspdPrice: 0,
          pspdPsdvolume: data.rjXl,
          pspdPslowerlimit: data.limdLownum,
          pspdPsmoney: 0,
          pspdPsnumber: 0,
          pspdPsnvolume: data.stockNum,
          pspdPsownumber: data.ztSl,
          pspdPsprice: 0,
          pspdPsupperlimit: data.limdHighnum,
          pspdReserves1: "",
          pspdReserves2: "",
          pspdReserves3: "",
          pspdReserves4: "",
          pspdReserves5: "",
          pspdReserves6: "",
          pspmId: "",
          stId: data.stId,
        };
        this.selectDataTable = false;
      },
  
      initActionBox() {
        for (let key in this.sendDataInfo) {
          this.sendDataInfo[key] = "";
        }
  
        this.sendDataInfo.pspmSupdays = 0;
        this.dataActionBox.actionType = 0;
        this.dataActionBox.showStatus = false;
      },
  
      openBox(cate, formData, mainId, oldData = "") {
        this.showTabs = formData[0].jciName;
        this.formDataList = formData;
        if (cate == 0) {
          this.dataActionBox.boxTitle = "新增信息";
          this.dataActionBox.openMode = "ltr";
        } else {
          this.dataActionBox.boxTitle = "编辑信息";
          this.dataActionBox.openMode = "rtl";
          for (let key in oldData) {
            this.sendDataInfo[key] = oldData[key];
          }
        }
        this.dataActionBox.actionType = cate;
        this.dataActionBox.showStatus = true;
        this.$nextTick(()=>{
          this.getMainInput()
        this.initFocus()
        })
       
      },
      sendDataAction(sendDataInfo) {
        this.$refs[sendDataInfo][0].validate((valid) => {
          if (valid) {
            this.sub();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
  
      },
      async sub() {
        let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
        this.$parent.getData(sendData);
        this.initActionBox();
      },
  
  
      // 获取字典数据 5：商品分类
      // async getPartDictionariesData() {
      //   let responseData = await this.$http.getPartDictionariesData({ ids: [5] });
      //   if (responseData.status == 200) {
      //     if (responseData.result.spfl) {
      //       this.goodsCate = responseData.result.spfl;
      //     }
      //   } else {
      //     this.$message({
      //       message: responseData.message,
      //       type: "error",
      //     });
      //   }
      // },
      // 获取主表单所有input
      getMainInput() {
        var el = document.getElementById('mainInfo')//获取所有input
        if (el) this.inputel = el.getElementsByTagName('input')
      },
      // 初始化焦点
      initFocus() {
        console.log(this.inputel)
        for (let index = 0; index < this.inputel.length; index++) {
          if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
            this.inputel[index].focus()
            break
          }
        }
      },
      // 输入框切换焦点
      nextFocus(index) {
        if (index >= (this.inputel.length - 1)) return
        var aindex = index + 1
        if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
          this.nextFocus(aindex)
          return
        }
        this.inputel[aindex].focus()
      },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      // this.getPartDictionariesData();
      this.getAllStorageRoom();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { 
      
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
      this.getMainInput()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
  };
  </script>
  <style scoped>
  .table_button_box {
    height: 200px;
    background-color: red;
  }
  .table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
  }
  </style>